var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasSucceeded)?_c('div',[_vm._v(" "+_vm._s(_vm.memberSince)+" ")]):(_vm.hasFailed)?_c('div',{staticClass:"c-other-state"},[_vm._v(" "+_vm._s(_vm.$t('invites.invitees.state_failed'))+" ")]):_c('div',{staticClass:"c-other-state"},[_vm._v(" "+_vm._s(_vm.$t('invites.invitees.state_open'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }